import React from 'react';
import { PriceDisplay } from './PriceDisplay';
import { CTABlock } from './CTABlock';
import { Lock, Smartphone, ShieldCheck, Crown } from 'lucide-react';
export function OfferStack() {
  return <section id="cart" className="bg-forest-900 py-20 px-4" data-id="element-81">
      <div className="max-w-2xl mx-auto" data-id="element-82">
        <div className="rounded-3xl shadow-2xl overflow-hidden border border-gold-400/30 bg-white" data-id="element-83">
          {/* Header */}
          <div className="bg-forest-900 text-gold-400 p-6 flex items-center justify-center gap-3 border-b-4 border-gold-500" data-id="element-84">
            <Crown className="w-8 h-8" data-id="element-85" />
            <h3 className="text-2xl md:text-3xl font-bold tracking-wide" data-id="element-86">
              Resumen de Todo lo que Recibís:
            </h3>
          </div>

          <div className="p-6 md:p-10" data-id="element-87">
            {/* Value Summary */}
            <div className="space-y-4 mb-10" data-id="element-88">
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-89">
                <span className="font-bold text-lg min-w-0" data-id="element-90">
                  5 Tomos Protocolo Rescate SIBO
                </span>
                <span className="font-bold text-lg whitespace-nowrap shrink-0 ml-3" data-id="element-91">
                  <PriceDisplay amount={26950} data-id="element-92" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-93">
                <span className="font-medium min-w-0" data-id="element-94">
                  Bono 1: Kit SOS Panza Globo
                </span>
                <span className="font-medium whitespace-nowrap shrink-0 ml-3" data-id="element-95">
                  <PriceDisplay amount={2990} data-id="element-96" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-97">
                <span className="font-medium min-w-0" data-id="element-98">
                  Bono 2: Mapa de Compras
                </span>
                <span className="font-medium whitespace-nowrap shrink-0 ml-3" data-id="element-99">
                  <PriceDisplay amount={1990} data-id="element-100" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-101">
                <span className="font-medium min-w-0" data-id="element-102">
                  Bono 3: Tracker 14 Días
                </span>
                <span className="font-medium whitespace-nowrap shrink-0 ml-3" data-id="element-103">
                  <PriceDisplay amount={1990} data-id="element-104" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-105">
                <span className="font-medium min-w-0" data-id="element-106">
                  Bono 4: Comer Afuera Sin Explotar
                </span>
                <span className="font-medium whitespace-nowrap shrink-0 ml-3" data-id="element-107">
                  <PriceDisplay amount={1990} data-id="element-108" />
                </span>
              </div>
              <div className="flex justify-between items-center text-forest-800 pb-4 border-b border-forest-800/10" data-id="element-109">
                <span className="font-medium min-w-0" data-id="element-110">
                  Bono 5: Ritual Nocturno 10/10
                </span>
                <span className="font-medium whitespace-nowrap shrink-0 ml-3" data-id="element-111">
                  <PriceDisplay amount={1990} data-id="element-112" />
                </span>
              </div>
              <div className="flex justify-between items-center pt-4" data-id="element-113">
                <span className="text-xl font-bold text-forest-900 min-w-0" data-id="element-114">
                  VALOR TOTAL
                </span>
                <span className="text-xl font-bold text-forest-800/60 line-through whitespace-nowrap shrink-0 ml-3" data-id="element-115">
                  <PriceDisplay amount={37900} data-id="element-116" />
                </span>
              </div>
              <div className="flex items-center bg-forest-50 p-6 rounded-2xl border border-forest-100 mt-6" data-id="element-117">
                <span className="w-1/2 text-2xl md:text-3xl font-bold text-forest-900" data-id="element-118">
                  PAGÁS SOLO
                </span>
                <span className="w-1/2 text-2xl md:text-3xl font-bold text-gold-500 whitespace-nowrap text-right" data-id="element-119">
                  <PriceDisplay amount={19990} data-id="element-120" />
                </span>
              </div>
            </div>

            {/* Single CTA */}
            <CTABlock href="https://checkout.tumundoglobal.online/cart/45328607871167:1" className="w-full text-xl md:text-2xl py-5" data-id="element-121">
              ACCEDER AHORA
            </CTABlock>
          </div>
        </div>
      </div>
    </section>;
}